const GetDeviceIcon = {
  methods: {
    /**
     * Devuelve el icono de la unidad seleccionado por el usuario
     *
     * Existen dos listados de iconos, unos de altherma y otros de aire
     * También hay un icono específico cuando se muestra en el listado de ACS
     *
     * @param {Number} - número del icono
     * @return {String} - nombre del icono
     */
    GetDeviceIcon(device, ACSMode) {
      if (ACSMode) return 'unit-acs-9';
      if (device.acs_available) return `unit-acs-${device.icon}`;
      return `unit-${device.icon}`;
    },
  },
};

export default GetDeviceIcon;
